import { Icon } from "../../Icon";
import { IIcon } from "../../interfaces/IIcon";

export const imageIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" rx="3"/><path fill="#FFF" fill-rule="nonzero" d="M21.5 24.5a3.001 3.001 0 016 0 3 3 0 11-6 0zM35.429 26l-4.319 6.75-4.253-3.308L20 39.5h24L35.429 26zM47 17v30H17V17h30zm3-3H14v36h36V14z"/></svg>`
);
